// 服务端：Redis处理方法

import { CACHEOR_KEYS } from "@/constants/cacheor";

type Cachor = {
  get(option: { key: CACHEOR_KEYS; type?: "json" }): Promise<any>;
  set(option: {
    key: CACHEOR_KEYS;
    value: string | object;
    ttl?: number;
  }): Promise<void | false>;
  del(key: CACHEOR_KEYS): Promise<void | false>;
  getGroceryKey(path: string): string;
  getGrocery(options: {
    path: string;
    disableCache?: boolean;
    saveToCache?: boolean;
    ttl?: number;
  }): Promise<any>;
  expireGrocery(option: { path: string }): Promise<void | false>;
};

//@ts-ignore
export let cacheor: Cachor = {};

export function initCacheor(res) {
  Object.assign(cacheor, res.redisCache || {});
}
